const isSafeReason = (value) => typeof value === 'string'
    && value.length <= 240
    && !/payload\s*=|error\s*=|\{\s*"?(method|code|data)"?\s*:/i.test(value)

const getErrorText = (error) => {
    if (typeof error === 'string') return isSafeReason(error) ? error : ''
    if (!error || typeof error !== 'object') return ''
    return [error.reason, error.shortMessage].find(isSafeReason) || ''
}

export function mapStakingError(error, t = (value) => value) {
    const message = getErrorText(error).trim()
    const knownMessage = [message, error?.message, error?.error?.message].filter(Boolean).join(' ')
    if (error?.code === 4001 || /rejected|denied|cancelled/i.test(knownMessage)) return t('您已取消钱包操作')
    if (/not reach/i.test(knownMessage)) return t('未到达解锁时间')
    if (/not wl/i.test(knownMessage)) return t('邀请用户暂未质押代币, 无法绑定上下级关系')
    if (/insufficient funds|insufficient balance|balance too low|exceeds balance/i.test(knownMessage)) return t('余额不足')
    if (/caller is not token owner|not (?:the )?(?:token )?(?:owner|holder)|non-owner/i.test(knownMessage)) return t('您不是此NFT的持有者')
    if (/invalid token id|nonexistent token|owner query for nonexistent token/i.test(knownMessage)) return t('请输入有效的Token ID')
    if (/already (?:added|in (?:the )?list)|duplicate/i.test(knownMessage)) return t('此NFT已在列表中')
    if (/amount above limit|stake amount above limit|exceeds (?:the )?(?:stake )?limit/i.test(knownMessage)) return t('质押数量超过上限')
    return message || t('交易失败，请稍后重试')
}
